import React, { useEffect, useState } from 'react'

import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	FormGroup,
	Input,
	Row,
	Col,
	Label,
	FormFeedback,
} from "reactstrap";

import useForm from "../../formValidator/userForm";
import "./styles.css";

import Loader from '../../components/Loader'

import { DEPARTMENT } from '../../configs/urls'
import { STATUS_LIST } from '../../configs/constant'
import { getApi, postApi, putApi } from '../../services/api'
import { useHistory } from 'react-router-dom'

const DepartmentOperations = (props) => {

	const [isRequesting, setIsRequestig] = useState(false)
	const [actionTitle, setActionTitle] = useState('Add Department')
	const history = useHistory()

	useEffect(() => {
		if (props.match && props.match.params) {
			if (!props.match.params.department_id) {
				params.status = 1
			} else {
				setActionTitle('Update department')

				setIsRequestig(true);
				const url = `${DEPARTMENT}/${props.match.params.department_id}`
				getApi(url)
					.then((res) => {
						params.name = res.data.name
						params.status = res.data.status
					}, (err) => {
						console.log(err);
					}).finally(() => {
						setIsRequestig(false);
					})

			}
		}
	}, [])

	const validate = (values) => {
		let errors = {};

		if (!values.name) {
			errors.name = "Department Name is required";
		}

		return errors;
	};

	const saveUpdateDepartment = () => {
		setIsRequestig(true);

		if (props.match && props.match.params && props.match.params.department_id) {
			putApi(`${DEPARTMENT}/${props.match.params.department_id}`, params).then((res) => {
				history.goBack()
			}, () => {

			}).finally(() => {
				setIsRequestig(false);
			});
		} else {
			postApi(DEPARTMENT, params)
				.then(
					(res) => {
						history.goBack()
					},
					(err) => { }
				)
				.finally(() => {
					setIsRequestig(false);
				});
		}
	}

	const { params, errors, handleChange, handleSubmit } = useForm(
		saveUpdateDepartment,
		validate
	);

	return (
		<div className="content">
			<Loader isLoading={isRequesting} />
			<form onSubmit={handleSubmit}>
				<Card className="card-user">
					<CardHeader>
						<CardTitle tag="h5">{actionTitle}</CardTitle>
					</CardHeader>
					<hr />
					<CardBody>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<label>Department Name</label>
									<Input
										type="text"
										name="name"
										placeholder="Department Name"
										value={params.name || ""}
										onChange={handleChange}
										invalid={errors.name && errors.name.length > 0 ? true : false}
									/>
									<FormFeedback>{errors.name}</FormFeedback>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<Label for="status">Status</Label>
									<Input
										type="select"
										name="status"
										id="status"
										value={params.status}
										onChange={handleChange}
										invalid={errors.status && errors.status.length > 0 ? true : false}
									>
										{
											STATUS_LIST.map(status => (
												<option key={status.id} value={status.id}>{status.title}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.status}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<div className="update ml-auto mr-auto">
								<Button
									className="btn-round"
									color="primary"
									type="submit"
								>
									{actionTitle}
								</Button>
							</div>
						</Row>
					</CardBody>
				</Card>
			</form>
		</div>
	)
}

export default DepartmentOperations